import { TrackedAnchor } from '@/components/ancher';
import React from 'react';
import {
  CTA_PILL_CLASSNAME,
  CTA_PILL_TEXT_CLASSNAME,
} from '@/components/button/cta-pill.constants';

export interface CtaButtonProps {
  label: string;
  link: string;
  index: number;
}

const CtaButton: React.FC<CtaButtonProps> = ({ label, link, index }) => {
  return (
    <div className="flex justify-center">
      <TrackedAnchor
        label={`cta-button_${index + 1}`}
        position="main_cta"
        href={link}
        className={`${CTA_PILL_CLASSNAME} no-underline`}
        target="_blank"
      >
        <span className={CTA_PILL_TEXT_CLASSNAME}>{label}</span>
      </TrackedAnchor>
    </div>
  );
};

export default CtaButton;
